import LoginLayout from '../core/layout/login/login.layout'

const LoginPage = () => {
    return <LoginLayout />
}

export default LoginPage
